/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BucketPathPartitionSpec } from '../models/BucketPathPartitionSpec';
import { FileFormat } from '../models/FileFormat';
import { PartitionType } from '../models/PartitionType';

export class GcsSourceProperties {
  /**
  * The GCS bucket name
  */
  'bucket': string;
  /**
  * The GCS prefix (path) within the bucket
  */
  'prefix'?: string;
  /**
  * The GCP project ID that owns the bucket
  */
  'projectId': string;
  /**
  * The GCS location where the bucket is located
  */
  'location': string;
  'fileFormat': FileFormat;
  'partitionType': PartitionType;
  'bucketPathPartitionSpec': BucketPathPartitionSpec;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "bucket",
      "baseName": "bucket",
      "type": "string",
      "format": ""
    },
    {
      "name": "prefix",
      "baseName": "prefix",
      "type": "string",
      "format": ""
    },
    {
      "name": "projectId",
      "baseName": "projectId",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "fileFormat",
      "baseName": "fileFormat",
      "type": "FileFormat",
      "format": ""
    },
    {
      "name": "partitionType",
      "baseName": "partitionType",
      "type": "PartitionType",
      "format": ""
    },
    {
      "name": "bucketPathPartitionSpec",
      "baseName": "bucketPathPartitionSpec",
      "type": "BucketPathPartitionSpec",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcsSourceProperties.attributeTypeMap;
  }

  public constructor() {
  }
}



